import { render, staticRenderFns } from "./StorageUsageBanner.vue?vue&type=template&id=2eaa88c0&scoped=true"
import script from "./StorageUsageBanner.vue?vue&type=script&setup=true&lang=ts"
export * from "./StorageUsageBanner.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./StorageUsageBanner.vue?vue&type=style&index=0&id=2eaa88c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eaa88c0",
  null
  
)

export default component.exports